(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-coupon-message"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ltt-cart-coupon')) {
  class LttCartCoupon extends HTMLElement {
    constructor() { super(); this.handleCopy = this.handleCopy.bind(this); }
    connectedCallback() {
      this.addEventListener('click', this.handleCopy, true);
      queueMicrotask(() => { if (this.isConnected) this.initializeButton(); });
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handleCopy, true);
      clearTimeout(this.resetTimer); this.resetFeedback();
    }
    initializeButton() {
      if (this.button && this.contains(this.button)) return;
      this.code = this.dataset.couponCode;
      if (!this.code) return;
      const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => {
          const parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;
          const excluded = parent.closest('a, button, textarea, script, style, svg, [hidden], [aria-hidden="true"], .ltt-cart-coupon__status');
          if (excluded && this.contains(excluded)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      let node;
      while ((node = walker.nextNode())) {
        let start = node.data.indexOf(this.code);
        while (start !== -1) {
          const before = node.data[start - 1] || '';
          const after = node.data[start + this.code.length] || '';
          if (!/[\p{L}\p{N}_-]/u.test(before) && !/[\p{L}\p{N}_-]/u.test(after)) { this.createButton(node, start); return; }
          start = node.data.indexOf(this.code, start + this.code.length);
        }
      }
    }
    createButton(node, start) {
      this.button = document.createElement('button');
      this.button.type = 'button'; this.button.className = 'ltt-cart-coupon__button';
      this.button.setAttribute('aria-label', this.dataset.copyLabel); this.button.title = this.dataset.copyLabel;
      this.label = document.createElement('span'); this.label.className = 'ltt-cart-coupon__label'; this.label.textContent = this.code;
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('class', 'ltt-cart-coupon__icon'); icon.setAttribute('width', '16'); icon.setAttribute('height', '16'); icon.setAttribute('viewBox', '0 0 24 24'); icon.setAttribute('fill', 'none'); icon.setAttribute('stroke', 'currentColor'); icon.setAttribute('stroke-width', '1.7'); icon.setAttribute('stroke-linecap', 'round'); icon.setAttribute('stroke-linejoin', 'round'); icon.setAttribute('aria-hidden', 'true'); icon.setAttribute('focusable', 'false');
      this.iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path'); icon.append(this.iconPath); this.button.append(this.label, icon);
      const codeNode = node.splitText(start); codeNode.splitText(this.code.length); codeNode.replaceWith(this.button);
      this.status = this.querySelector('.ltt-cart-coupon__status'); this.resetFeedback();
    }
    resetFeedback() {
      if (!this.button) return;
      this.label.textContent = this.code;
      this.iconPath.setAttribute('d', 'M10 8h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2Zm6 0V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3');
      this.removeAttribute('data-copy-error-visible'); if (this.status) this.status.textContent = '';
    }
    async handleCopy(event) {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.ltt-cart-coupon__button') !== this.button) return;
      event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
      if (this.copyPending) return;
      this.copyPending = true; clearTimeout(this.resetTimer); this.resetFeedback();
      try {
        await navigator.clipboard.writeText(this.code);
        if (!this.isConnected) return;
        this.label.textContent = this.dataset.copySuccess; this.iconPath.setAttribute('d', 'm5 12 4 4L19 6'); this.status.textContent = this.dataset.copySuccess;
        this.resetTimer = setTimeout(() => this.resetFeedback(), 3000);
      } catch (error) {
        if (!this.isConnected) return;
        this.setAttribute('data-copy-error-visible', ''); this.status.textContent = this.dataset.copyError;
      } finally { this.copyPending = false; }
    }
  }
  customElements.define('ltt-cart-coupon', LttCartCoupon);
}
  } catch(e) { console.error(e); }
})();

})();
